const BaseXform = require('../../base-xform');
const CSerXform = require('./c-ser-xform');

class CAreaChart extends BaseXform {
  constructor() {
    super();

    this.map = {
      'c:ser': new CSerXform(),
    };
  }

  get tag() {
    return 'c:areaChart';
  }

  render(xmlStream, model) {
    xmlStream.openNode(this.tag);

    this.map['c:ser'].render(xmlStream, model);
    xmlStream.closeNode();
  }

  parseOpen(node) {
    if (this.parser) {
      this.parser.parseOpen(node);
      return true;
    }

    switch (node.name) {
      case this.tag:
        this.reset();
        break;

      default:
        this.parser = this.map[node.name];
        if (this.parser) {
          this.parser.parseOpen(node);
        }
        break;
    }
    return true;
  }

  parseText(text) {
    if (this.parser) {
      this.parser.parseText(text);
    }
  }

  parseClose(name) {
    if (this.parser) {
      if (!this.parser.parseClose(name)) {
        this.parser = undefined;
      }
      return true;
    }
    switch (name) {
      case this.tag:
        this.model = this.map['c:ser'].model;
        return false;
      default:
        return true;
    }
  }
}

module.exports = CAreaChart;
